import { useEffect } from 'react';
import { NextRouter } from 'next/router';
import { validateStoreVariables } from '~/helpers/validateStoreVariables';

/**
 * Custom hook that validates store variables based on the current route.
 * It checks if required variables (address and selectedProductId) are present
 * depending on the current page route.
 * For now it only validates the address and selectedProductId
 *
 * @param {string | undefined} address - The user's address from the store
 * @param {string | undefined} selectedProductId - The selected product ID from the store
 * @param {NextRouter} router - Next.js router instance
 *
 * @example
 * useStoreVariablesValidation(address, selectedProductId, router);
 */
export function useStoreVariablesValidation(
  address: string | undefined,
  selectedProductId: string | undefined,
  router: NextRouter
): void {
  useEffect(() => {
    if (router.isReady) {
      validateStoreVariables({
        url: router.asPath,
        address,
        selectedProductId,
      });
    }
  }, [router.isReady, router.asPath, address, selectedProductId]);
}
